module.exports = __webpack_public_path__ + "static/instagram_post-639d4178559757d810864e7f76c112b9.webp";